import React, { useCallback, useEffect, useRef, useState } from "react";
import { renderStats } from "./GameLogic/gameStatistics";
import Overworld from "./GameLogic/Overworld";
import "./global.css";
import "./TextMessage.css";
import "./SceneTransition.css";
import Api from "../../utils/api";
import { useNavigate } from "react-router-dom";
import applicantData from "./GameLogic/init";
import LoadingScreen from "../../components/LoadingScreen";
import { useSnackbar } from "notistack";

export default function GameScreen() {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const overworldRef = useRef(null);
  const navigate = useNavigate();

  const showSuccSnack = useCallback((message) => {
    enqueueSnackbar(message, {
      variant: "success",
      preventDuplicate: true,
      autoHideDuration: 3000,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
  }, [enqueueSnackbar]);

  useEffect(() => {
    const apiInstance = new Api(localStorage.getItem("jwt"));

    let nots = localStorage.getItem("nots");
    if (nots !== null) {
      localStorage.removeItem("nots");
      showSuccSnack(nots);
    }
    const getTreasureData = async () => {
      const data = await apiInstance.getTreasureData();
      if (data === "err") {
        localStorage.clear();
        localStorage.setItem(
          "err",
          "Something went wrong! Contact us on Discord for assistance!"
        );
        navigate("/", { replace: true });
        return;
      }
      if (data.status) {
        var tids = data.data.treasureIds;
        tids.forEach((tid) => {
          applicantData.treasuresObtained.add(tid);
        });
        setLoading(false);
      } else {
        localStorage.setItem("err", data.description);
        navigate("/", { replace: true });
        return;
      }
    };
    getTreasureData();
  }, [navigate, showSuccSnack]);

  useEffect(() => {
    if (loading) {
      return;
    }

    let rafId = null;

    const startOverworld = () => {
      const container = document.querySelector(".gameContainer");
      if (!container) {
        // Defer boot until React commits the game container to the DOM.
        rafId = requestAnimationFrame(startOverworld);
        return;
      }

      if (overworldRef.current) {
        return;
      }

      overworldRef.current = new Overworld({ element: container });
      renderStats();
      overworldRef.current
        .init()
        .catch((err) => console.error("Failed to init overworld", err));
    };

    startOverworld();

    return () => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
      overworldRef.current = null;
    };
  }, [loading]);

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <>
          {" "}
          <div className="gameBody">
            <div className="absolute z-10 bottom-5 right-0 font-mono text-white overflow">
              Codename: {localStorage.getItem("reg") ?? "Anon Eagle"}
            </div>
            <div className="absolute z-10 bottom-0 right-0 text-white font-mono overflow">
              Version 1.0
            </div>
            <div className="gameStatistics"></div>
            <div className="gameInteract"></div>
            <div className="gameContainer">
              <canvas className="gameCanvas"></canvas>
            </div>
          </div>
        </>
      )}
    </>
  );
}
